import { useTranslation } from "react-i18next";
import CoolnetPageLayout from "./components/CoolnetPageLayout";
import Layout from "@/components/feature/Layout";
import SEO from "@/components/feature/SEO";
import { coolnetUPS } from "@/mocks/coolnet";

export default function UPSPage() {
  const { t } = useTranslation("home");

  return (
    <Layout>
      <SEO
        title="Sistemas UPS Coolnet | Ventra Core Mexico"
        description="Sistemas de alimentacion ininterrumpida UPS Coolnet de 1 a 600 kVA. Series PGH y PGM en torre y rack. Distribuidor autorizado Coolnet en Mexico."
        keywords="UPS Coolnet, sistema UPS, alimentacion ininterrumpida, PGH, PGM, energia respaldo, centros de datos, Leon Mexico"
        canonical="https://ventracore.com.mx/coolnet/sistema-ups"
        schemas={[
          {
            "@context": "https://schema.org",
            "@type": "Product",
            "@id": "https://ventracore.com.mx/coolnet/sistema-ups#product",
            "name": "Sistemas UPS Coolnet",
            "brand": {
              "@type": "Brand",
              "name": "Coolnet",
            },
            "description": "Sistemas de alimentacion ininterrumpida UPS Coolnet de 1 a 600 kVA.",
            "offers": {
              "@type": "AggregateOffer",
              "availability": "https://schema.org/InStock",
              "priceCurrency": "MXN",
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Inicio",
                "item": "https://ventracore.com.mx/",
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Coolnet",
                "item": "https://ventracore.com.mx/coolnet",
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Sistema UPS",
                "item": "https://ventracore.com.mx/coolnet/sistema-ups",
              },
            ],
          },
        ]}
      />
      <CoolnetPageLayout
        title={t("coolnetPage.ups.title")}
        subtitle={t("coolnetPage.ups.subtitle")}
      >
        <div className="max-w-5xl mx-auto">
          <p className="text-sm md:text-base text-text-muted leading-relaxed text-justify mb-10">
            {coolnetUPS.intro}
          </p>

          <h3 className="text-xl md:text-2xl font-bold text-magenta mb-8 uppercase tracking-wide">
            {t("coolnetPage.ups.productsTitle")}
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {coolnetUPS.products.map((product, index) => (
              <div
                key={index}
                className="bg-surface rounded-lg overflow-hidden hover:shadow-md transition-shadow"
              >
                <div className="w-full h-48 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-5">
                  <h4 className="text-base md:text-lg font-bold text-brandgreen mb-3">
                    {product.title}
                  </h4>
                  <p className="text-sm text-text-muted leading-relaxed">
                    {product.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-sm text-text-muted">{coolnetUPS.contact}</p>
          </div>
        </div>
      </CoolnetPageLayout>
    </Layout>
  );
}